import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'replaceIfEmpty',
    standalone: false
})
export class ReplaceIfEmptyPipe implements PipeTransform {
    transform(value: string, toReplace = null): string {
        if(value && value.length > 0){
            return value;
        }

        if(toReplace){
            return toReplace;
        }

        return "not provided";
    }
}